import { ForwardIcon } from 'tombac-icons';

interface Props {
  bearing: number;
}

export const BearingIcon: React.FC<Props> = ({ bearing }: Props) => {
  return <ForwardIcon style={{ transform: `rotate(${bearing - 90}deg)` }} />;
};
